export default {"src":"/_next/static/media/share-grey-inline.63796980.svg","height":21,"width":18,"blurWidth":0,"blurHeight":0};